import { ProfilePhoto } from 'modules/app/styles'
import { Fragment } from 'react'

function Avatar(props) {
  let username = props.user?.name?.split(' ') || ''
  let firstName = username[0] || ''
  let lastName = username[1] || ''
  return (
    <ProfilePhoto {...props}>
      {(props.user?.id || props.user?.name) && (
        <Fragment>
          {props.user?.avatar && <img src={props.user?.avatar} alt={props.user?.name} />}
          {!props.user?.avatar && (
            <Fragment>
              <span className='text-capitalize font-weight-600'>{firstName[0]}</span>
              <span className='text-capitalize'>{lastName[0]}</span>
            </Fragment>
          )}
        </Fragment>
      )}
      {props.children}
    </ProfilePhoto>
  )
}

export default Avatar
